module.exports = __webpack_public_path__ + "img/stu-pre-exam-bg-left.e78df910.svg";